import { ProductPayload, ProductsAction, Products } from "../interfaces/global-interfaces";

export default function productReducer(state: ProductPayload[] = [], action: Products) {
    switch (action.type) {
        case ProductsAction.Update:
            return [...action.payload];
        default:
            return state;
    }
}